import React from 'react';
import IconButton from "@material-ui/core/IconButton";
import NotificationsNoneOutlinedIcon from "@material-ui/icons/NotificationsNoneOutlined";
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import styles from '../styles';
import Badge from '@material-ui/core/Badge';
import Popover from '@material-ui/core/Popover';
import Typography from "@material-ui/core/Typography";
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined';
import ForumOutlinedIcon from '@material-ui/icons/ForumOutlined';
import PhoneCallbackOutlinedIcon from '@material-ui/icons/PhoneCallbackOutlined';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
import {history} from '~/router/history';
import {generatePath} from 'react-router';
import {OrderDetailsContainer} from "@components/orders/modals/order-details/order-details.container";
import {TaskInfoContainer} from '@components/user-tasks/modals/task-info/task-info.container';
import {CHAT} from "~/router/routes";
import {LEADS_LIST} from "~/router/routes";
import dayjs from 'dayjs';
import {Layout} from '@components/layout';
import clsx from "clsx";

const NotificationsComponent = ({classes, notifications, markAsReadNotifications}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openList, setOpenList] = React.useState(false);

    const notificationTypes = {
        order_created: 'App\\Notifications\\Order\\OrderCreatedNotification',
        chatBot_newMessage: 'App\\Notifications\\ChatBots\\NewMessageNotification',
        chatBot_newCallback: 'App\\Notifications\\ChatBots\\NewCallbackNotification',
        userTasks_CreateTask: 'App\\Notifications\\UserTasks\\UserTaskCreateTaskNotification',
        userTasks_Report: 'App\\Notifications\\UserTasks\\UserTaskReportNotification',
    };

    const notificationRender = (notification) => {
        switch (notification.type) {
            case notificationTypes.order_created:
                const { order } = notification.data;
                return <OrderDetailsContainer
                    key={'notification_' + notification.id}
                    customOpenButton={notificationLabelRender(
                        <LocalMallOutlinedIcon />,
                        `Создан новый заказ #${order.company_order_id} на сумму ${order.amount_total} грн`,
                        `${dayjs(notification.created_at).format('DD.MM.YYYY HH:mm')}`
                    )}
                    orderId={order.id}
                />
            case notificationTypes.chatBot_newMessage:
                const { message } = notification.data;
                return <React.Fragment key={'notification_' + notification.id}>
                    {notificationLabelRender(
                        <ForumOutlinedIcon />,
                        `Новое сообщение: ${message.room.username}`,
                        `${dayjs(notification.created_at).format('DD.MM.YYYY HH:mm')}`,
                        () => history.push(generatePath(`${CHAT}?chatId=${message.room.id}`))
                    )}
                </React.Fragment>
            case notificationTypes.chatBot_newCallback:
                const { lead } = notification.data;
                return <React.Fragment key={'notification_' + notification.id}>
                    {notificationLabelRender(
                        <PhoneCallbackOutlinedIcon />,
                        `Запрос на обратный вызов: ${lead.phone}`,
                        `${dayjs(notification.created_at).format('DD.MM.YYYY HH:mm')}`,
                        () => history.push(generatePath(`${LEADS_LIST}?search=${lead.phone}`))
                    )}
                </React.Fragment>
            case notificationTypes.userTasks_CreateTask:
                return <TaskInfoContainer
                    key={'notification_' + notification.id}
                    customOpenButton={notificationLabelRender(
                        <AssignmentIndOutlinedIcon />,
                        `Создана задача "${notification.data.task.title}".`,
                        `${dayjs(notification.created_at).format('DD.MM.YYYY HH:mm')}`,
                    )}
                    task={notification.data.task}
                    onTaskUpdate={() => {}}
                    onTaskDelete={() => {}}
                />
            case notificationTypes.userTasks_Report:
                return <TaskInfoContainer
                    key={'notification_' + notification.id}
                    customOpenButton={notificationLabelRender(
                        <AssignmentTurnedInOutlinedIcon />,
                        `Задача "${notification.data.task.title}" завершена, отчет создан.`,
                        `${dayjs(notification.created_at).format('DD.MM.YYYY HH:mm')}`,
                    )}
                    task={notification.data.task}
                    onTaskUpdate={() => {}}
                    onTaskDelete={() => {}}
                />
            default: return null
        }
    };

    const notificationLabelRender = (icon, title, subtitle, onClick = () => {}) => (<div
        className={classes.notification_label}
        onClick={onClick}
    >
        <div className={classes.notification_label__icon}>{icon}</div>
        <div className={classes.notification_label__text}>
            <Typography>{title}</Typography>
            <Typography variant={'caption'}>{subtitle}</Typography>
        </div>
    </div>);

    return (<div className={classes.notification}>
        <IconButton
            color="inherit"
            onClick={({currentTarget}) => setAnchorEl(currentTarget)}
        >
            <Badge
                badgeContent={notifications.length}
                color="secondary"
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <NotificationsNoneOutlinedIcon />
            </Badge>
        </IconButton>
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={() => {
                if (notifications.length > 0) {
                    markAsReadNotifications(notifications.map(notification => notification.id));
                }
                setAnchorEl(null);
                setOpenList(false);
            }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            PaperProps={{
                elevation: 0,
                square: true
            }}
            classes={{
                paper: classes.notification_paper
            }}
        >
            <div
                className={clsx(classes.notification_list, {
                    [classes.notification_list_notFound]: notifications.length === 0,
                })}
            >
                {notifications.length > 0
                    ? <>
                        {notifications.slice(0, openList ? undefined : 4).map(notification => notificationRender(notification))}

                        {notifications.length > 4 && !openList ? <div
                            className={classes.show_more_notification}
                            onClick={() => {
                                setOpenList(!openList)
                            }}
                        >
                            <Typography align={'center'}>Просмотреть все уведомления</Typography>
                        </div> : null}
                    </>
                    : <Typography>Ничего не найдено</Typography>
                }
            </div>
        </Popover>
    </div>)
};


const mapStateToProps = (state, props) => ({
    notifications: state.layout.notifications || [],
});

const actions = {
    markAsReadNotifications: Layout.actions.markAsReadNotifications,
};

export const NotificationsContainer = connect(mapStateToProps, actions)(withStyles(styles)(NotificationsComponent));
